const functionalMap = {
  gridTitle: "GAM Functional Map",
  lockedNotice: "Locked structure: 3 levels × 5 functions. Cannot add/remove cells.",
  levelStrategy: "Strategy",
  levelManagement: "Management",
  levelOperations: "Operations",
  funcSales: "Sales",
  funcDelivery: "Delivery",
  funcFinance: "Finance",
  funcHr: "HR",
  funcTechnology: "Technology",
  statusActive: "Active",
  statusPartial: "Partial",
  statusPlanned: "Planned",
  owner: "Owner",
  tools: "Tools",
  description: "Description",
  clickToEdit: "Click to edit",
  saving: "Saving...",
  saved: "Saved",
  legend: "Legend",
  noOwner: "Unassigned",
  realtimeConnected: "Connected",
  realtimeConnecting: "Connecting...",
  realtimeDisconnected: "Disconnected",
  items: "Items",
  addItem: "Add Item",
  itemPlaceholder: "New item...",
  noItems: "No items yet",
  notes: "Notes",
  kpis: "KPIs",
  addKpi: "Add KPI",
  noKpis: "No KPIs",
  links: "Links",
  addLink: "Add Link",
  noLinks: "No links",
  progress: "Progress",
  details: "Details",
  lastUpdated: "Updated",
  stale: "Stale",
  cells: "Cells",
  labelPlaceholder: "Label",
  valuePlaceholder: "Value",
  targetPlaceholder: "Target",
  daysAgo: "days ago",
  filterAll: "All",
} as const;
export default functionalMap;
